// extracted by mini-css-extract-plugin
module.exports = {"links":"Burger_links__32L8C","active":"Burger_active__2bk7a"};